import { app } from '../../../../bootstrap/core';
import { uploadState } from './upload.state';
import { uploadComponent } from './upload.component';
import { DataTypeField, UploadFields } from './upload.constants';
import ziraatBankUploadTemplateUrl from './templates/ziraat-bank.tpl.html';

app.config(uploadState);
app.constant('DataTypeField', DataTypeField);
app.value('UploadFields', UploadFields);
app.value('ZiraatBankUploadTemplateUrl', ziraatBankUploadTemplateUrl);

app.component(uploadComponent.name, uploadComponent);
